module.exports = __webpack_public_path__ + "static/timhortons-9bf9d7e642c96acba04f6872f5866f89.png";